import { featureFlags } from './feature-flags.js';
/**
 * @function
 * @template T
 * @param key {T} the string-key of the feature you're flagging
 * @param deploymentEnvironment {DeploymentEnvironment} if you want to pass in a deployment environment to override
 * @param override {FeatureFlags[T]} specify if you want to override the value
 * @returns {Promise<FeatureFlags[T]>}
 *
 * 🚨Warning: if you use `override`` on both frontend and backend for a
 * single feature, make sure you manage the feature's lifecycle correctly
 * e.g., remove override at the same time for both, or API first at least
 * */
export function getFeatureFlagValue(key, deploymentEnvironment, override) {
    const deployment = deploymentEnvironment || 'production';
    if (!(deployment in featureFlags)) {
        throw new Error(`Unsupported deployment environment provided for feature flags: ${deploymentEnvironment}`);
    }
    const deploymentFlags = featureFlags[deployment];
    if (!deploymentFlags || !(key in deploymentFlags)) {
        throw new Error(`Feature flag key does not exist for deployment environment: ${key}`);
    }
    const value = deploymentFlags[key];
    // console.debug('Get feature flag value', { key, value, override });
    if (override !== undefined) {
        return override;
    }
    return value;
}
//# sourceMappingURL=feature-flag.service.js.map